import { loadCatalogReducers } from './catalog';
import { loadCustomersReducers } from './customers';
import { loadOrdersReducers } from './orders';
import { loadMarketingReducers } from './marketing';
import { loadDesignReducers } from './design';
import { loadReportsReducers } from './reports';
import { loadStockReducers } from './stock';
import { loadPosPrintReducers } from './posPrint';
import { loadFinanceReducers } from './finance';

export const REDUCER_GROUP_LOADERS = {
  catalog: loadCatalogReducers,
  customers: loadCustomersReducers,
  orders: loadOrdersReducers,
  marketing: loadMarketingReducers,
  design: loadDesignReducers,
  reports: loadReportsReducers,
  stock: loadStockReducers,
  posPrint: loadPosPrintReducers,
  finance: loadFinanceReducers,
};

export const REDUCER_GROUP_IDS = Object.keys(REDUCER_GROUP_LOADERS);
